const bgs: string[][] = [
  [`58B6C8`, `9356B6`],
  [`863DDF`, `CA398F`],
  [`D9571D`, `DDB18F`],
  [`DE8957`, `D73E0D`],
  [`5752CC`, `00CED8`],
  [`A62959`, `AA99C1`],
  [`BAA3C3`, `8A5AC8`],
  [`65C9EF`, `C47D67`],
  [`FF9765`, `CB0B17`],
  [`D570AF`, `E4BEBF`],
  [`9BCDD9`, `DC96AD`],
  [`0053CE`, `B684D4`],
  [`008CDF`, `B66EE2`],
  [`E9B550`, `BE4C65`],
  [`F63069`, `8C2B7A`],
  [`3B169C`, `D75359`],
  [`D16DE4`, `1FC2CF`],
  [`325CD4`, `BE82A0`],
  [`A2243E`, `B4A0C9`],
  [`E1A897`, `D67789`],
  [`B96190`, `C1AACE`],
  [`CDA208`, `00ADBC`],
  [`177CD6`, `8C29A6`],
  [`73B06F`, `020253`]
]

export const getDecimalHash = (string: string | undefined = ''): number => {
  let sum: number = 0

  for (let i: number = 0; i < string.length; i++) {
    const codePoint = string.codePointAt(i)
    if (codePoint !== undefined) {
      sum += ((i + 1) * codePoint) / (1 << 8)
    }
  }

  return sum % 1
}

export default (string: string | undefined): string => {
  const bgIndex: number = Math.ceil(getDecimalHash(string) * (bgs.length - 1))
  const bg: string[] = bgs[bgIndex]
  return `linear-gradient(135deg, #${bg[0]} 0%, #${bg[1]} 100%);`
}
